function Tables() {
  const renderView = () => {
    return (
      <tr>
        <td>
          <div className="form-check">
            <input type="checkbox" className="form-check-input" />
            <label className="form-check-label"></label>
          </div>
        </td>
        <td>Jhon Deo</td>
        <td>rea</td>
        <td>sdg</td>
        <td>rea</td>
        <td>sdg</td>
        <td>$0</td>
        <td>$0</td>
      </tr>
    );
  };

  return (
    <div className="page-content leads-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0">Table</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Assigned to</th>
                      <th>Description</th>
                      <th>Created Date</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tables;
